// libraries.
import { Modal, Button } from "react-bootstrap";
import { monserratSemiBold, robotoRegular, scarpaGray500 } from "@habitech/shared";

// interfaces.
import { RawRuleItem } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

// styles.
import { StyledRulesModalForm } from "../styles";

interface Props {
  show: boolean;
  subRutaName: string;
  ganadores: RawRuleItem[];
  onConfirm: () => void;
  onClose: () => void;
}

const text = { base: robotoRegular, semi: monserratSemiBold };

export const ConfirmLockModal = ({
  show,
  subRutaName,
  ganadores,
  onConfirm,
  onClose,
}: Props) => (
  <Modal show={show} onHide={onClose} centered size="md">
    <Modal.Header closeButton style={{ borderBottom: "2px solid #0d9488" }}>
      <Modal.Title style={{ fontFamily: text.semi, fontWeight: 600, fontSize: 16 }}>
        🔒 Mover ruta a Confianza
      </Modal.Title>
    </Modal.Header>

    <Modal.Body style={{ background: "#f0fdfa", padding: "24px" }}>
      <StyledRulesModalForm>
        <p style={{ fontFamily: text.base, fontSize: 14, color: "#1a1a1a", marginBottom: 16 }}>
          Estás a punto de mover toda la ruta{" "}
          <strong style={{ fontFamily: text.semi }}>{subRutaName}</strong> a{" "}
          <strong style={{ fontFamily: text.semi }}>Confianza (hold out)</strong>.{" "}
          Estas reglas seguirán activas pero quedarán fuera del ciclo Winner/Contender.
        </p>

        <p
          style={{
            fontFamily: text.semi,
            fontSize: 11,
            color: "#0d9488",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            marginBottom: 8,
          }}
        >
          🏆 Reglas que pasarán a Confianza
        </p>

        <div style={{ border: "1px solid #99f6e4", borderRadius: 8, overflow: "hidden" }}>
          {ganadores.length === 0 ? (
            <p style={{ padding: "12px 14px", fontFamily: text.base, fontSize: 13, color: scarpaGray500, margin: 0 }}>
              Sin reglas ganadoras
            </p>
          ) : (
            ganadores.map((r, i) => (
              <div
                key={r.rule_id}
                style={{
                  padding: "8px 14px",
                  borderBottom: i < ganadores.length - 1 ? "1px solid #ccfbf1" : "none",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  background: "#f0fdfa",
                }}
              >
                <span
                  style={{
                    width: 20, height: 20, borderRadius: "50%",
                    background: "#ccfbf1",
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                    fontSize: 10, fontWeight: 700, color: "#0d9488", flexShrink: 0,
                  }}
                >
                  {r.rule.priority}
                </span>
                <span style={{ fontFamily: text.base, fontSize: 13, color: "#333" }}>
                  {r.rule.name}
                </span>
              </div>
            ))
          )}
        </div>

        <p style={{ fontFamily: text.base, fontSize: 11, color: "#0d9488", marginTop: 6 }}>
          Pasarán a Confianza (state_route → 3)
        </p>
      </StyledRulesModalForm>
    </Modal.Body>

    <Modal.Footer style={{ borderTop: "1px solid #99f6e4", background: "#f0fdfa" }}>
      <Button className="btn-habi-white" onClick={onClose}>
        Cancelar
      </Button>
      <Button
        onClick={onConfirm}
        disabled={ganadores.length === 0}
        style={{
          background: "#0d9488",
          borderColor: "#0d9488",
          fontFamily: robotoRegular,
          fontSize: 14,
        }}
      >
        🔒 Confirmar hold out
      </Button>
    </Modal.Footer>
  </Modal>
);
